export enum RowStatus {
Active = 1,
Inactive = 2,
Delete = 3
} 


// WEBPACK FOOTER //
// ./src/app/common/enums/row-status.enum.ts